import React from "react";

import styles from "../../../../styles/apple-pay-domain.module.scss";

import { EnvironmentStorage } from "@tools/EnvironmentStorage";
import { Context } from "pages/Integrations";
import { Label, Button, Drawer, Loading } from "@components";
import ApplePayAddDomainDrawer from "./ApplePayAddDomainDrawer";
import { Icon } from "shared/components/core/Icon";
import { IntegrationsAPI } from "providers/IntegrationsAPI";

export default class ApplePayDomainDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: false,
      loading: false,
      fileContent: null,
      domains: [],
    };
  }

  componentDidMount() {
    this.loadConfigs();
  }

  async loadConfigs() {
    const environmentId = EnvironmentStorage.getEnvironment().id;

    const domainsResponse = await IntegrationsAPI.getApplePayDomains(
      environmentId
    );

    const domains = domainsResponse.getData([]);

    this.setState({
      loadingPage: false,
      domains: domains,
    });
  }

  getDomainUrl(domain) {
    return `https://${domain}/.well-known/apple-developer-merchantid-domain-association.txt`;
  }

  render() {
    const { loadingPage, domains } = this.state;
    const { onClose } = this.props;

    return (
      <Drawer
        visible
        onClose={onClose}
        closeInFade
        title={"Apple Pay - Domínios"}
        footer={
          <Button
            design="primary"
            className="w-100"
            onClick={() => this.setState({ openAddDomain: true })}
          >
            Adicionar domínio
          </Button>
        }
      >
        <Context />

        {loadingPage ? (
          <div className="d-flex justify-center align-center h-100">
            <Loading fullScreen />
          </div>
        ) : (
          <div className={styles.scrollContainer}>
            <Label>Domínios ({domains.length})</Label>

            {domains.length === 0 ? (
              <div className={styles.empty}>
                <Icon name="fa-link" light size="2x" />
                <p>Nenhum domínio cadastrado.</p>
              </div>
            ) : (
              <div className="mb-20">
                {domains.map((domain) => (
                  <div className={styles.domain} key={domain.domain}>
                    <p className={styles.domainAddress}>{domain.domain}</p>
                    <p className={styles.domainFile}>
                      <a href={this.getDomainUrl(domain.domain)} rel="noreferrer" target="_blank">
                        {domain.file?.name}
                      </a>
                    </p>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {this.state.openAddDomain && (
          <ApplePayAddDomainDrawer
            onSave={() => {
              this.setState({ openAddDomain: false });
              this.loadConfigs();
            }}
            onClose={() => {
              this.setState({ openAddDomain: false });
            }}
          />
        )}
      </Drawer>
    );
  }
}
